import { Link } from "gatsby"
import React from "react"
import { FaArrowRight } from "react-icons/fa"
import MapArgentina from "../../../images/map-argentina.png"
import MapUsa from "../../../images/map-usa.png"
import MapEcuador from "../../../images/map-ecuador.png"
import BgArgentina from "../../../images/bg-office-argentina.png"
import BgUsa from "../../../images/bg-office-usa.png"
import BgEcuador from "../../../images/bg-office-ecuador.png"

const Maps = () => {
  return (
    <section>
      <div
        className="bg-center bg-no-repeat bg-cover"
        style={{ backgroundImage: `url(${BgArgentina})` }}
      >
        <div className="container mx-auto grid grid-cols-1 lg:grid-cols-2 gap-0 md:gap-4">
          <div className="col-start-2">
            <div className="bg-secondary bg-opacity-90 p-8 rounded-2xl text-white mt-16 mb-32 w-5/6 md:w-3/4 mx-auto md:mx-0">
              <h3 className="text-3xl pb-4">Argentina</h3>
              <p className="pb-4">
                Olavarría 2660, C.P.: B7600FXR, Mar del Plata, Buenos Aires
              </p>
              <img
                src={MapArgentina}
                alt="Argentina Office"
                className="mx-auto"
              />
              <Link
                to="/contact"
                title="Get In Touch"
                className="pt-8 pb-4 block font-medium text-xl"
              >
                Get In Touch{" "}
                <FaArrowRight className="animate-pulse inline text-xl ml-1" />
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div
        className="bg-center bg-no-repeat bg-cover my-4"
        style={{ backgroundImage: `url(${BgUsa})` }}
      >
        <div className="container mx-auto grid grid-cols-1 md:grid-cols-2 gap-0 md:gap-4">
          <div className="col-start-1 w-5/6 md:w-11/12 lg:w-5/6 mx-auto">
            <div className="bg-secondary bg-opacity-90 p-8 rounded-2xl text-white mt-16 mb-32 mx-auto lg:mx-0">
              <h3 className="text-3xl pb-4">United States</h3>
              <p className="pb-4">
                470 Ansin Blvd Ste K, Hallandale Beach, Florida, 33009
              </p>
              <img
                src={MapUsa}
                alt="USA Office"
                className="mx-auto"
              />
              <Link
                to="/contact"
                title="Get In Touch"
                className="pt-8 pb-4 block font-medium text-xl"
              >
                Get In Touch{" "}
                <FaArrowRight className="animate-pulse inline text-xl ml-1" />
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div
        className="bg-center bg-no-repeat bg-cover"
        style={{ backgroundImage: `url(${BgEcuador})` }}
      >
        <div className="container mx-auto grid grid-cols-1 lg:grid-cols-2 gap-0 md:gap-4">
          <div className="col-start-2">
            <div className="bg-secondary bg-opacity-90 p-8 rounded-2xl text-white mt-16 mb-32 w-5/6 md:w-3/4 mx-auto md:mx-0">
              <h3 className="text-3xl pb-4">Ecuador</h3>
              <p className="pb-4">Calle 3 S/N, Ayampe, Manabi, 130315</p>
              <img
                src={MapEcuador}
                alt="Ecuador Office"
                className="mx-auto"
              />
              <Link
                to="/contact"
                title="Get In Touch"
                className="pt-8 pb-4 block font-medium text-xl"
              >
                Get In Touch{" "}
                <FaArrowRight className="animate-pulse inline text-xl ml-1" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Maps
